import { render, staticRenderFns } from "./T5.vue?vue&type=template&id=29f5f23d&"
import script from "./T5.vue?vue&type=script&lang=js&"
export * from "./T5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports